module.exports = __webpack_public_path__ + "components/carousel-news-posts/static/generic-bg--10-174a583f27e7a9cdf8c2163a1363bcb5.jpg";